import { Checkbox as Checkb, Form, CheckboxProps } from 'antd';
import { Checkbox } from '@mui/material'; 
import { ChangeEventHandler } from 'react';

const CheckboxF = (props: { width?: number, name: string, value?: any, label?: string, defauldVal?: any, offst?: number, CheCkDefauld?: boolean,required?:boolean ,dissabled?:boolean,onChange?: ChangeEventHandler}) => {

  let Check = props.CheCkDefauld ? true : false;
  return (
    <>
      <Form.Item  preserve={true}  required={props.required?props.required:false} valuePropName='checked' label={props.label} labelCol={{ span: props.width, offset: props.offst }} className='bordure' initialValue={Check} name={props.name} >
        <Checkbox size='small' disabled={props.dissabled} onChange={props.onChange} />
      </Form.Item>
    </>
  )
}


export default CheckboxF;

